import { MUIMarkdown } from '@modules/common/components/MUIMarkdown/MUIMarkdown';
import { renderToStaticMarkup } from 'react-dom/server';

export const convertMarkdownToHTML = (markdown: string): string => {
  const html = renderToStaticMarkup(<MUIMarkdown markdown={markdown} />);
  return html;
};
